import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { PortalActivityFilter, PortalActivityPage, PortalContactStatus } from './portalAdmin.service';

// ---- F8 supplier portal (staff side) ----
export interface SupplierPortalSettings {
  institutionId: string; serverConfigured: boolean; supplierPortalEnabled: boolean; emailEnabled: boolean;
}
export interface SupplierPortalContact {
  id: string; supplierId: string; name: string; email: string; status: PortalContactStatus;
  lastLoginAt?: string | null; lockedUntil?: string | null; disabledReason?: string | null; createdAt?: string;
}
export interface SupplierOneTimeLink {
  contact: SupplierPortalContact; url: string; expiresAt: string; emailed: boolean; emailedTo?: string | null;
}

const E = ENDPOINTS.SUPPLIER_PORTAL_ADMIN;
const clean = (f: PortalActivityFilter) => Object.fromEntries(Object.entries(f).filter(([, v]) => v));

export const SupplierPortalAdminService = {
  getSettings: async (i: string): Promise<SupplierPortalSettings> => (await axios.get(E.SETTINGS(i))).data,
  saveSettings: async (i: string, supplierPortalEnabled: boolean): Promise<SupplierPortalSettings> =>
    (await axios.put(E.SETTINGS(i), { supplierPortalEnabled })).data,
  contacts: async (i: string, supplierId: string): Promise<SupplierPortalContact[]> =>
    (await axios.get(E.CONTACTS(i, supplierId))).data,
  /** sendEmail is the explicit "also e-mail it" tick; nothing is ever mailed without it. */
  invite: async (i: string, supplierId: string, body: { name: string; email: string; sendEmail: boolean }): Promise<SupplierOneTimeLink> =>
    (await axios.post(E.CONTACTS(i, supplierId), body)).data,
  reinvite: async (i: string, contactId: string, sendEmail = false): Promise<SupplierOneTimeLink> =>
    (await axios.post(E.REINVITE(i, contactId), { sendEmail })).data,
  resetLink: async (i: string, contactId: string, sendEmail = false): Promise<SupplierOneTimeLink> =>
    (await axios.post(E.RESET_LINK(i, contactId), { sendEmail })).data,
  unlock: async (i: string, contactId: string): Promise<SupplierPortalContact> => (await axios.post(E.UNLOCK(i, contactId))).data,
  deactivate: async (i: string, contactId: string, reason: string): Promise<SupplierPortalContact> =>
    (await axios.post(E.DEACTIVATE(i, contactId), { reason })).data,
  reactivate: async (i: string, contactId: string): Promise<SupplierPortalContact> => (await axios.post(E.REACTIVATE(i, contactId))).data,
  activity: async (i: string, supplierId: string, f: PortalActivityFilter, page = 0, size = 50): Promise<PortalActivityPage> =>
    (await axios.get(E.ACTIVITY(i, supplierId), { params: { ...clean(f), page, size } })).data,
};
// ---- end F8 ----
